import { useState } from "react";

export enum QueryParamsStatus {
  FIND_BY_PROVINCE = "findByProvince",
  FIND_BY_DISTRICT = "findByDistrict",
  FIND_BY_MUNICIPALITY = "findByMunicipality",
  FIND_BY_WARD = "findByWard",
  FIND_BY_JOB_TYPE = "findByJobType",
  FIND_BY_GENDER = "findByGender",
  IS_AVAILABLE = "isAvailable",
  SEARCH_BY = "searchBy",
  PAGE = "page",
  PAGE_SIZE = "pageSize",
}
export interface QueryParamsConfig {
  recruiterId?: string | null;
  jobId?: string | null;
  findByProvince?: string | null;
  findByDistrict?: string | null;
  findByMunicipality?: string | null;
  findByWard?: string | null;
  findByJobType?: string | null;
  findByGender?: string | null;
  isAvailable?: boolean | null;
  searchBy?: string | null;
  page?: number;
  pageSize?: number;
  isLastPage?: boolean;
}

export const initialState: QueryParamsConfig = {
  recruiterId: null,
  findByProvince: null,
  findByDistrict: null,
  findByMunicipality: null,
  findByWard: null,
  findByJobType: null,
  findByGender: null,
  isAvailable: null,
  searchBy: null,
  page: 1,
  pageSize: 10,
};

const useFilterPagination = () => {
  const [queryParamaters, setQueryParameters] = useState(initialState);

  const onTableChange = (page: number, pageSize: number) => {
    setQueryParameters({
      ...queryParamaters,
      page: page,
      pageSize: pageSize,
    });
  };

  const onSearch = (value: string, key: QueryParamsStatus) => {
    setQueryParameters({ ...queryParamaters, [key]: value });
  };

  const onFilterChange = (value: string, key: QueryParamsStatus) => {
    setQueryParameters({
      ...queryParamaters,
      [key]: value,
    });
  };

  return {
    queryParamaters,
    setQueryParameters,
    onSearch,
    onTableChange,
    onFilterChange,
  };
};

export { useFilterPagination };